import { useStockCost } from "@erp/shared/components/ui/Document/_composable/useStockCost";
import { defineStore } from "pinia";
export const useEstimateStockCostStore = defineStore("useEstimateStockCostStore", useStockCost);
